import React from "react";
import { useNavigate } from "react-router-dom";
import "./Subscriptions.css";

export default function Subscriptions() {
  const navigate = useNavigate();

  return (
    <div className="subs-page">
      <div className="subs-card">
        <div className="subs-top">
          <h1>Upgrade</h1>
          <p>Unlock premium features like boosts, unlimited likes, and advanced filters.</p>
        </div>

        <div className="subs-grid">
          <div className="plan">
            <h3>Basic</h3>
            <div className="price">Free</div>
            <ul>
              <li>Limited likes</li>
              <li>Standard matching</li>
              <li>Basic chat</li>
            </ul>
            <button className="btn ghost" onClick={() => navigate("/app")}>
              Continue Free
            </button>
          </div>

          <div className="plan featured">
            <div className="badge">Popular</div>
            <h3>Premium</h3>
            <div className="price">
              MWK 9,999 <span>/ month</span>
            </div>
            <ul>
              <li>Unlimited likes</li>
              <li>See who liked you</li>
              <li>1 Boost / week</li>
              <li>Advanced filters</li>
            </ul>
            <button className="btn primary" onClick={() => alert("Hook PayChangu here")}>
              Upgrade Now
            </button>
          </div>

          <div className="plan">
            <h3>VIP</h3>
            <div className="price">
              MWK 24,999 <span>/ month</span>
            </div>
            <ul>
              <li>Everything in Premium</li>
              <li>Unlimited boosts</li>
              <li>Priority visibility</li>
              <li>VIP badge</li>
            </ul>
            <button className="btn outline" onClick={() => alert("Hook PayChangu here")}>
              Go VIP
            </button>
          </div>
        </div>

        <div className="subs-footer">
          <button className="link" onClick={() => navigate(-1)}>
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
}